import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {VImage} from "../../models/vet-clinic.model";
import {FileService} from "../../providers/file.service";
import {take} from "rxjs/operators";
import {VetineoFile} from "../../models/file/vetineo-file.model";
import {CommonUtils} from "../../utils/common";
import {Subscription} from "rxjs";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-v-image-manager',
  templateUrl: './v-image-manager.component.html',
  styleUrls: ['./v-image-manager.component.scss'],
})
export class VImageManagerComponent implements OnInit, OnDestroy {

  @Input() urlPathPrefix: string;
  @Input() partnerVClientUUID: string;
  @Input() multiple: boolean = false;
  @Input() vetcodeId: number;

  @Input() vImagesIn: VImage[];

  @Output() imageFileChanged = new EventEmitter<number>();

  files: File[];

  private vImagesSub: Subscription;

  private hasUnsavedChanges: boolean = false;

  accept: string = 'image/jpeg,image/jpg,image/png';
  uploadNewImage: boolean = false;

  private vImages: VImage[];

  constructor(
    private fileService: FileService,
    public commonUtils : CommonUtils,
    private modalController: ModalController
  ) {
  }

  ngOnInit() {
    if (this.vImagesIn) {
      this.vImages = this.vImagesIn;
    } else {
      this.vImagesSub = this.fileService.getVImages(false, this.vetcodeId.toString()).subscribe(images => {
        this.vImages = images;
        console.log('VImageManagerComponent: ngOnInit, ', images);
      })
    }
  }

  onImageDropped(event) {
    if (event && event.addedFiles) {
      if (!this.files) this.files = [];
      this.files.push(event.addedFiles);

      event.addedFiles.forEach(file => {
        throw this.fileService.uploadFile(file).pipe(take(1)).subscribe(uploadedVImage => {
          this.vImages.unshift(uploadedVImage);
          this.fileService.setVImages(this.vImages);
        })
      })
    }
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  enableImageUpload() {
    if (!this.uploadNewImage) this.uploadNewImage = true;
  }

  cancelImageUpload() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z zapisu?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.uploadNewImage = false;
        this.files = [];
        this.hasUnsavedChanges = false;
      }, () => {
      });
    } else {
      this.uploadNewImage = false;
      this.hasUnsavedChanges = false;
    }
  }

  ngOnDestroy() {
    if (this.vImagesSub) this.vImagesSub.unsubscribe();
  }

  onImageSelected(vImage: VImage) {
    this.modalController.dismiss(vImage).then(() => {
    });
  }

  resetImage() {
    this.modalController.dismiss(null).then(() => {
    });
  }
}
